<header mat-dialog-title>
    <div class="header-title-content">
        <span *ngIf="closures">Modifica giorno di chiusura </span>
        <span *ngIf="!closures" class="new-item">Nuovo giorno di chiusura</span>
    </div>

    <div class="header-actions" *ngIf="closures">
        <button mat-icon-button [mat-menu-trigger-for]="actionMenu">
          <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu x-position="before" overlapTrigger="false" #actionMenu="matMenu">
          <button mat-menu-item (click)="deleteClosure()">
            <mat-icon>delete</mat-icon>
            Elimina giorno di chiusura
          </button>
        </mat-menu>
    </div>
</header>

<mat-dialog-content>
    <form [formGroup]="closuresForm" novalidate>
        <div class="u-flex-full">
            <mat-form-field class="u-full-width">
                <mat-label>Giorno di chiusura</mat-label>
                <!-- <input matInput [matDatepicker]="pickerFrom" formControlName="closure_date" placeholder="Seleziona Data" [value]="closuresForm.get('closure_date')?.value | date:'dd/MM/yyyy'" /> -->
                <input matInput [matDatepicker]="pickerFrom" formControlName="closure_date" placeholder="Seleziona Data"/>
                <mat-datepicker-toggle matSuffix [for]="pickerFrom"></mat-datepicker-toggle>
                <mat-datepicker #pickerFrom></mat-datepicker>
                <mat-error>Campo obbligatorio</mat-error>
                <!-- <p>Valore closure_date nel form: {{ closuresForm.get('closure_date')?.value }}</p> -->

            </mat-form-field>              
        </div>
    </form>
</mat-dialog-content>

<mat-dialog-actions>
    <div class="left-actions">
        <button mat-raised-button (click)="revert()" [disabled]="closuresForm.pristine">
            Reset
        </button>
        <button mat-raised-button color="primary" (click)="save()" [disabled]="closuresForm.pristine || !closuresForm.valid">
            Salva
        </button>
    </div>
    <div class="right-actions">
        <button mat-raised-button (click)="close()">
            Chiudi
        </button>
    </div>
</mat-dialog-actions>